module.exports = __webpack_public_path__ + "img/ep7-1.6e147cc4.png";